import { useWorkspace } from "../contexts/WorkspaceContext";

export function WorkspaceSwitcher() {
  const { workspaces, activeWorkspace, setActiveWorkspace } = useWorkspace();

  return (
    <div className="p-3 border-b border-white/[0.08]">
      <select
        className="w-full bg-field border border-white/[0.08] rounded-lg pl-2 pr-8 py-1.5 text-sm text-ink-2 focus:outline-none focus:border-brand transition-colors"
        value={activeWorkspace?.id ?? ""}
        onChange={(e) => {
          const ws = workspaces.find((w) => w.id === e.target.value) ?? null;
          setActiveWorkspace(ws);
        }}
      >
        <option value="">Personal</option>
        {workspaces.map((ws) => (
          <option key={ws.id} value={ws.id}>
            {ws.name}
          </option>
        ))}
      </select>
    </div>
  );
}
